const styles = {
  container: {
    display: "flex",
    flexDirection: window.innerWidth <= 1200 ? "column" : "row", // Switch to column on mobile
    justifyContent: "space-between",
    height: "calc(100vh - 60px)", // Adjust based on TopBar height
    padding: "10px",
  },
  leftSection: {
    flex: 3,
    marginRight: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    maxWidth: window.innerWidth <= 1200 ? "100%" : "50%", // Full width on mobile
  },
  rightSection: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "10px",
    boxSizing: "border-box",
    maxWidth: window.innerWidth <= 1200 ? "100%" : "50%", // Full width on mobile
  },
  verticalScrollContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  chatContainer: {
    flex: 1,
    overflowY: "auto",
    marginBottom: "10px",
  },
  fileTreeContainer: {
    flex: 1,
    overflowY: "auto",
    marginTop: "10px",
  },
};

export default styles;
